/*
 ** vue router: QAF
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtQAF: RouteRecordRaw = {
  path: '/eservices/qaf',
  name: 'vrtQAF',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'reference',
      name: 'vrtQAFReference',
      component: () => import('./vpgQAFReference.vue'),
    },
    {
      path: 'myqaf',
      name: 'vrtQAFMyQAF',
      component: () => import('./vpgQAFMyQAF.vue'),
    },
    {
      path: 'vo',
      name: 'vrtQAFVO',
      component: () => import('./vpgQAFVO.vue'),
    },
    {
      path: 'vooperate',
      name: 'vrtQAFVOOperate',
      component: () => import('./vpgQAFVOOperate.vue'),
    },
    {
      path: 'ao',
      name: 'vrtQAFAO',
      component: () => import('./vpgQAFAO.vue'),
    },
    {
      path: 'aooperate',
      name: 'vrtQAFAOOperate',
      component: () => import('./vpgQAFAOOperate.vue'),
    },
    {
      path: 'hrreport',
      name: 'vrtQAFHRReport',
      component: () => import('./vpgQAFHRReport.vue'),
    },
    {
      path: 'adminqafsetdateclosed',
      name: 'vrtAdminQAFSetDateClosed',
      component: () => import('./vpgAdminQAFSetDateClosed.vue'),
    },
    {
      path: 'adminqafgradelist',
      name: 'vrtAdminQAFGradeList',
      component: () => import('./vpgAdminQAFGradeList.vue'),
    },
    {
      path: 'adminqafgradeoperate',
      name: 'vrtAdminQAFGradeOperate',
      component: () => import('./vpgAdminQAFGradeOperate.vue'),
    },
  ],
};

export default vrtQAF;
